import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { memo } from 'react';
import { keyBy } from 'lodash';
import { Autocomplete, Grid, TextField } from '@emburse/ui-core';
const ExpenseTagBucketsFormControls = ({ multiple, xs = 6, expenseTagsBucketsForUser, activeExpenseBucketsWithActiveTags, selectedExpenseTagsByBucketId = {}, textExpenseTagsByBucketId = {}, disabled, onExpenseTagChange }) => {
    const expenseTagBucketControls = expenseTagsBucketsForUser.map((bucketDetail) => {
        const bucketId = bucketDetail.id;
        let selectedValueOrValues; // Will be string for multiple=false, string[] for multiple=true
        const expenseTagBucketsWithExpenseTagsById = keyBy(activeExpenseBucketsWithActiveTags, 'id');
        if (bucketDetail.input_type === 'dropdown' && expenseTagBucketsWithExpenseTagsById[bucketId].expense_tags) {
            selectedValueOrValues = selectedExpenseTagsByBucketId[bucketId];
        }
        if (disabled) {
            // reset selected value
            selectedValueOrValues = multiple ? [] : '';
        }
        const renderDropDown = () => {
            const dropdownSelectedValue = multiple
                ? (selectedValueOrValues || []).map((selectedTagId) => expenseTagBucketsWithExpenseTagsById[bucketId].expense_tags.find((tag) => tag.id === selectedTagId))
                : expenseTagBucketsWithExpenseTagsById[bucketId].expense_tags.find((tag) => tag.id === selectedValueOrValues);
            const multiAutocompleteProps = multiple ? { multiple, checkbox: true, multipleType: 'text' } : {};
            return (
            // @ts-ignore
            _jsx(Autocomplete, Object.assign({}, multiAutocompleteProps, { useVirtualization: true, label: bucketDetail.name, value: dropdownSelectedValue, defaultValue: dropdownSelectedValue, options: expenseTagBucketsWithExpenseTagsById[bucketId].expense_tags, getOptionLabel: (opt) => opt.name, disabled: disabled, onChange: (_, value) => {
                    let idOrIds;
                    if (!multiple) {
                        idOrIds = value ? value.id : '';
                    }
                    else {
                        idOrIds = value.map((val) => val.id);
                    }
                    onExpenseTagChange(bucketId, idOrIds);
                } }), Boolean(dropdownSelectedValue)));
        };
        return (_createElement(Grid, Object.assign({ item: true }, (typeof xs === 'number' ? { xs } : {}), { key: bucketId }),
            bucketDetail.input_type === 'text' && (_jsx(TextField, { fullWidth: true, label: bucketDetail.name, value: disabled ? '' : textExpenseTagsByBucketId[bucketId] || '', onChange: (event) => onExpenseTagChange(bucketId, event.target.value), disabled: disabled })),
            bucketDetail.input_type === 'dropdown' && renderDropDown()));
    });
    return _jsx(_Fragment, { children: expenseTagBucketControls });
};
const MemoizedExpenseTagBucketsFormControls = memo(ExpenseTagBucketsFormControls);
export { MemoizedExpenseTagBucketsFormControls as ExpenseTagBucketsFormControls };
